import type React from 'react';
import { Button } from '@music-vine/cadence/ui';
import { Foxtrot } from '@music-vine/cadence/ui';
import { Text } from '@music-vine/cadence/ui';
import { useSettings } from '@/hooks/state/useSettings';
import { useSubscriptionButtonState } from '@/hooks/billing/useSubscriptionButtonState';
import { cn } from '@/lib/utils';
import type { PlanDetails } from './types';
const PlanHeaderCell: React.FC<{
  plan: PlanDetails;
  fallbackCurrencySymbol?: string;
}> = ({
  plan,
  fallbackCurrencySymbol
}) => {
  // Get button state from the hook
  const buttonStates = useSubscriptionButtonState({
    plans: [{
      type: plan.key
    }]
  });
  const {
    settings
  } = useSettings();
  const currencySymbol = settings?.currency.symbol_left ?? fallbackCurrencySymbol;
  const buttonState = buttonStates[0];

  // A subscriber's current plan shows an outlined "Manage plan" CTA rather
  // than the solid plan-colour button.
  const isManage = buttonState.buttonType === 'manage';
  const formattedPrice = (() => {
    if (typeof plan.price === 'number') {
      return plan.price === 0 ? `${currencySymbol}0` : `${currencySymbol}${plan.price.toFixed(2)}`;
    }
    if (typeof plan.price === 'string') {
      return plan.price === 'Free' ? 'Free' : `${currencySymbol}${plan.price}`;
    }
    return `${currencySymbol}0`;
  })();
  return <th className="relative w-1/5 px-4 pt-4 pb-6 text-left align-top" key={plan.key} data-sentry-component="PlanHeaderCell" data-sentry-source-file="PlanHeaderCell.tsx">
      <div className="flex h-full flex-col">
        <div className="mb-1 flex items-center">
          <Foxtrot asChild className="mr-2 dark:text-white" data-sentry-element="Foxtrot" data-sentry-source-file="PlanHeaderCell.tsx">
            <h3>{plan.name}</h3>
          </Foxtrot>
        </div>
        <Text className="min-h-[20px] font-normal font-sans dark:text-gray-400" data-sentry-element="Text" data-sentry-source-file="PlanHeaderCell.tsx">
          {formattedPrice === 'Free' ? plan.subtitle : <>
              <strong className="font-semibold text-gray-950 dark:text-gray-50">
                {formattedPrice}
              </strong>
              {plan.period}
            </>}
        </Text>
        <div className="mt-auto pt-4">
          <Button className={cn('w-full rounded-md font-semibold', isManage && 'border border-brand-primary! border-solid text-brand-primary hover:bg-brand-secondary dark:border-white!')} disabled={buttonState.isDisabled} onClick={buttonState.onClick} variant={isManage ? 'transparent' : plan.buttonVariant} data-sentry-element="Button" data-sentry-source-file="PlanHeaderCell.tsx">
            {buttonState.buttonText}
          </Button>
        </div>
      </div>
    </th>;
};
export default PlanHeaderCell;